// Auto-generated by pipeline
export const firebaseConfig = {
  "authDomain": "roberto-shinyashiki-9fff3.firebaseapp.com",
  "projectId": "roberto-shinyashiki-9fff3",
  "storageBucket": "roberto-shinyashiki-9fff3.appspot.com",
  "messagingSenderId": "595960084272",
  "appId": "1:595960084272:web:da5babc635f9bf49187af5",
  "measurementId": "G-9D7FR280E9",
  "apiKey": "AIzaSyBX0M2TqAzuGbi0SNQJzZFLoyEAnf-dJnM"
};
